import {HierarchyNodeSelectedEventArgs} from './../hierarchy-tree/hierarchy-tree.component';
import {Component, OnInit} from '@angular/core';
import {EmitterService} from '../../service/EmitterService';
import {MatDatepickerInputEvent} from '@angular/material';
import * as moment from 'moment';
import {ActivatedRoute} from '@angular/router';
import {Action} from '../../model/action';
import {FormControl} from '@angular/forms';
@Component({
  selector: 'app-timesheet',
  templateUrl: './timesheet.component.html',
  styleUrls: ['./timesheet.component.css']
})
export class TimesheetComponent implements OnInit {
  agentName = null;
  teamName = null;
  siteName = null;
  agents = [];
  title: any = null;
  public valueDate: any =  new FormControl((new Date()).toISOString());
  public minDate: any = new Date(2000, 0, 1);
  public maxDate: any = new Date();
  public _isNow = false;

  constructor(private eventEmitter: EmitterService, private route: ActivatedRoute) { }

  ngOnInit() {
    this._isNow = this.isNow(this.valueDate.value)
    const usernameSearching =  this.route.snapshot.paramMap;//.get("username")
    const dateSearching =  this.route.snapshot.paramMap.get("date")
    console.log(usernameSearching, dateSearching)
    this.maxDate = moment(new Date()).add(Action['now'], 'days').toDate();
    this.eventEmitter.getChangeEmitter().subscribe((eventArgs: any) => {
      this.agents = eventArgs.members;
      if(this.agents && this.agents.length > 0){
        this.agents[0]['villeLabel'] = eventArgs.villeLabel;
      }
      this.title = [eventArgs.siteName, eventArgs.teamName, eventArgs.agentName];// console.log(this.title);
      console.error('titre:', this.title)
      this.title = this.title.filter(d => d && d.length > 0 && (d !== '' || d !== null)).join(' > ');
    });
  }

  onHierarchyTreeNodeActivated(eventArgs: HierarchyNodeSelectedEventArgs) {
    this.agents = eventArgs.members;
    this.title = [eventArgs.siteName, eventArgs.teamName, eventArgs.agentName];
    this.title = this.title.filter(d => d && d.length > 0 && (d !== null || d !== ''));
    this.title = this.title.join(' > ');
  }

  public ChangeDateGlobal(event: MatDatepickerInputEvent<Date>) {
    this.eventEmitter.emithDate(event.value);
    this._isNow = this.isNow(this.valueDate.value)
  }

  public GetQuerySearch(type?, data?) {
    if (type === 1) { return data; }
    this.route.queryParams.subscribe( param => this.GetQuerySearch(0, param));
  }
  Goto(type) {
    let i = 0;
    switch (type) {
      case 'next': i = i + 1 ;break;
      case 'prev': i = i - 1 ;break;
    }
    const d = new Date(this.valueDate.value);
    d.setDate(d.getDate() + i);
    this.valueDate = new FormControl(d.toISOString())
    this._isNow = this.isNow(this.valueDate.value)
    this.eventEmitter.emithDate(this.valueDate.value);
  }
  isNow(d) {
    const d1 = moment(d, 'YYYY-MM-DD').format('YYYY-MM-DD');
    const d2 = moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD');
    return  moment(d1).isSame(d2);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/timesheet/timesheet.component.ts